import React, { useState, useEffect } from "react";
import SpotifyPlayer from "react-spotify-player";
import { mediaQueries } from "../shared/config";

const DESKTOP_SIZE = {
    width: "90%",
    height: 400,
};
const MOBILE_SIZE = {
    width: 270,
    height: 200,
};

const SpotifyEmbed = (props) => {
    const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    media.addEventListener('change', () => {
        if (media.matches !== isMobile) {
          setIsMobile(media.matches);
        }
    });

    // Embed uses URI and not link
    // URI can be extracted from the link - the alphanumeric bit after '/album/'
    const URI = "spotify:playlist:" + props.link.substring(34);

    if (isMobile) {
        return <SpotifyPlayer uri={URI} theme="white" size={MOBILE_SIZE} />;
    }
    else {
        return <SpotifyPlayer uri={URI} theme="white" size={DESKTOP_SIZE} />;
    }
};

export default SpotifyEmbed;
